import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";

const FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLScwmlKtcdAO52nEev9tOLcjChdQEr2Z8TjugUdBYuAN_IQwLg/viewform";
const FORMULIR_PDF_URL =
  "https://drive.google.com/file/d/1vZcT0eSmt7OZMuvyctobVn-zq2Pq-bbw/view";

export default function Keberatan() {
  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main className="px-6 pb-20 pt-28 md:px-12 md:pt-32">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Pengajuan Informasi Publik — Pengajuan Keberatan
          </p>
          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] text-[#0B2440] md:text-6xl">
            Pengajuan Keberatan
          </h1>
          <div className="mt-6 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        </Reveal>

        <Reveal delay={0.1}>
          <ol
            data-testid="keberatan-list"
            className="mt-12 max-w-3xl list-decimal space-y-6 pl-6 text-[15px] leading-relaxed text-slate-600 marker:font-semibold marker:text-[#0B2440] md:text-base"
          >
            <li>
              Layanan informasi di LLDIKTI Wilayah VII dikelola oleh Pejabat
              Pengelola Informasi dan Dokumentasi (PPID) yaitu Kepala Bagian
              Umum dengan dibantu oleh Tim Pelaksana PPID. Unit layan
              informasi publik diselenggarakan oleh Unit Layanan Terpadu
              (ULT) di bawah koordinasi Tim Kerja Kehumasan LLDIKTI Wilayah
              VII dengan alamat di kantor LLDIKTI Wilayah VII, JL Dr. Ir. H.
              Soekarno, No. 177, Surabaya;
            </li>
            <li>
              Pemohon informasi yang telah menerima tanggapan tertulis dari
              LLDIKTI Wilayah VII dan dinilai tidak memenuhi permintaan
              informasi dan atau alasan lainnya sesuai dengan Undang-undang
              Keterbukaan Informasi Publik Nomor 14 Tahun 2008 dapat
              mengajukan keberatan informasi kepada Atasan PPID LLDIKTI
              Wilayah VII. Alasan tersebut meliputi: a) informasi yang diminta
              termasuk dalam informasi yang dikecualikan; b) tidak
              disediakannya informasi publik secara berkala; c) tidak
              ditanggapinya permohonan informasi publik; d) permohonan
              informasi publik tidak sebagaimana yang diminta; e) tidak
              diperuntinya permohonan informasi publik; f) pengenaan biaya
              yang tidak wajar; dan g) penyampaian informasi publik melebihi
              jangka waktu yang diatur dalam Undang-Undang tersebut.
            </li>
            <li>
              Sesuai ketentuan Undang-undang tersebut, jangka waktu pengajuan
              keberatan informasi selambat-lambatnya 30 (tiga puluh) hari
              kerja sejak diterimanya tanggapan tertulis dari LLDIKTI Wilayah
              VII. Formulir pengajuan keberatan dapat diunduh di sini:{" "}
              <a
                href={FORMULIR_PDF_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="keberatan-formulir-link"
                className="font-semibold text-[#1479BF] hover:underline"
              >
                Formulir Keberatan.pdf;
              </a>
            </li>
            <li>
              Pengajuan keberatan dapat disampaikan langsung melalui Unit
              Layanan Terpadu di kantor LLDIKTI Wilayah VII atau secara
              online. Silahkan{" "}
              <a
                href={FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="keberatan-klik-disini-link"
                className="font-semibold text-[#1479BF] hover:underline"
              >
                KLIK DISINI
              </a>{" "}
              atau klik menu dibawah untuk menyampaikan keberatan secara
              online.
            </li>
            <li>
              Dalam waktu maksimal 30 hari kerja sejak diterimanya pengajuan
              keberatan informasi dari pemohon informasi yang telah
              teregister, Atasan PPID LLDIKTI Wilayah VII akan memberikan
              tanggapan tertulis atas pengajuan keberatan informasi tersebut;
            </li>
            <li>
              Atasan PPID LLDIKTI Wilayah VII dalam hal ini Kepala LLDIKTI
              Wilayah VII.
            </li>
          </ol>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-12 flex justify-center">
            <a
              href={FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="keberatan-submit-button"
              className="inline-flex items-center justify-center rounded-full bg-[#1479BF] px-8 py-4 text-xs font-bold tracking-[0.08em] text-white transition-colors duration-300 hover:bg-[#0B2440] md:text-sm"
            >
              AJUKAN KEBERATAN
            </a>
          </div>
        </Reveal>
      </main>
      <Footer compact />
    </div>
  );
}
